import { addBreadcrumb, captureException } from '@sentry/react';
import geoService from 'legacyfrontend/api/services/geoService';
import jwtDecode from 'jwt-decode';
import apiApplications from '../../api/aplicaciones';
import apiGeo from '../../api/destinations';
import marcaBlancaServices from '../../api/services/marcaBlancaServices';
import * as types from './action-types';

const defaultCurrencyArs = {
  id: 1,
  code: 'ARS',
  description: 'Peso Argentino',
};

function getApplicationSuccess(data) {
  // SERVER // FP2.5LF
  return {
    type: types.GET_APPLICATION,
    payload: data,
  };
}
function getNavigationSuccess(data) {
  return {
    type: types.GET_NAVIGATION,
    payload: data,
  };
}

function getCitySuccess(data) {
  return {
    type: types.ADD_CITY,
    payload: data,
  };
}

const setAppInitialData = (data) => {
  // SERVER
  return {
    type: types.SET_APP_INITIAL_DATA,
    payload: data,
  };
};

const setTemplateData = (data) => {
  // SERVER
  return {
    type: types.SET_TEMPLATE_DATA,
    payload: data,
  };
};

export function getNavigation() {
  return function action(dispatch) {
    const modulos = window.location.pathname.split('/');
    const modulo = modulos[2] === undefined || modulos[2] === '' ? 'paquetes' : modulos[2];
    const data = { actualModule: modulo };
    return dispatch(getNavigationSuccess(data));
  };
}

export function getApplication(host) {
  // FP2.1LF
  return function action(dispatch) {
    return apiApplications
      .obtenerAplicacion(host) // FP2.2LF
      .then((res) => {
        const data = jwtDecode(res.access_token); //  FP2.3LF
        data.web = host;
        data.token = res.access_token;
        data.currency = res.currency || defaultCurrencyArs;

        return dispatch(getApplicationSuccess(data)); // FP2.4LF
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          console.error(`[Not found: ${host}]`);
        }
        throw error;
      });
  };
}

export const addCityEncapsulated = (code, dispatch) => {
  return apiGeo
    .standAloneGetCityByCode(code)
    .then((res) => {
      return dispatch(getCitySuccess(res));
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error(`[error] no se encontro la ciudad: ${code}`);
      // eslint-disable-next-line no-console
      console.error(err.config);
    });
};

export function getAppInitialData() {
  return async function action(dispatch, getState) {
    const store = getState();
    const appId = store.applicationState.applicationId;

    return marcaBlancaServices
      .initApp(appId, store)
      .then((res) => {
        return dispatch(setAppInitialData(res));
      })
      .catch((error) => {
        addBreadcrumb({
          message: `Fail with application ID ${appId}`,
          level: 'FATAL',
        });
        captureException(error);
        throw error;
      });
  };
}

export function getAppTemplateData() {
  return async function action(dispatch, getState) {
    const store = getState();
    const appId = store.applicationState.applicationId;

    return marcaBlancaServices
      .getTemplate(appId, store)
      .then((res) => {
        return dispatch(setTemplateData(res));
      })
      .catch((error) => {
        addBreadcrumb({
          message: `Fail with application ID ${appId}`,
          level: 'FATAL',
        });
        captureException(error);
        throw error;
      });
  };
}

export function getGeoData() {
  return async function action(dispatch, getState) {
    const [cities, localities] = await Promise.all([
      geoService.getCities(),
      geoService.getLocalities(),
    ]);
    const sortByDescription = (a, b) =>
      a.descripcion > b.descripcion ? 1 : b.descripcion > a.descripcion ? -1 : 0;

    return dispatch({
      type: types.SET_GEO_DATA,
      payload: {
        cities: [...cities.data].sort(sortByDescription),
        localities: [...localities.data].sort(sortByDescription),
      },
    });
  };
}
